const locale = {
    placeholder: 'Selectează ora',
    rangePlaceholder: ['Ora de început', 'Ora de sfârșit'],
};
export default locale;
